import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const fancybox = () => {
  Fancybox.bind("[data-fancybox]", {
    // Your options go here
  });
}

export default fancybox;
